/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClientSearchResult } from './ClientSearchResult';
import {
    ClientSearchResultFromJSON,
    ClientSearchResultFromJSONTyped,
    ClientSearchResultToJSON,
    ClientSearchResultToJSONTyped,
} from './ClientSearchResult';

/**
 * 
 * @export
 * @interface SearchResultsOfClientSearchResult
 */
export interface SearchResultsOfClientSearchResult {
    /**
     * 
     * @type {Array<ClientSearchResult>}
     * @memberof SearchResultsOfClientSearchResult
     */
    data: Array<ClientSearchResult>;
    /**
     * 
     * @type {boolean}
     * @memberof SearchResultsOfClientSearchResult
     */
    hasMoreItems: boolean;
}

/**
 * Check if a given object implements the SearchResultsOfClientSearchResult interface.
 */
export function instanceOfSearchResultsOfClientSearchResult(value: object): value is SearchResultsOfClientSearchResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('hasMoreItems' in value) || value['hasMoreItems'] === undefined) return false;
    return true;
}

export function SearchResultsOfClientSearchResultFromJSON(json: any): SearchResultsOfClientSearchResult {
    return SearchResultsOfClientSearchResultFromJSONTyped(json, false);
}

export function SearchResultsOfClientSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultsOfClientSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ClientSearchResultFromJSON)),
        'hasMoreItems': json['hasMoreItems'],
    };
}

export function SearchResultsOfClientSearchResultToJSON(json: any): SearchResultsOfClientSearchResult {
    return SearchResultsOfClientSearchResultToJSONTyped(json, false);
}

export function SearchResultsOfClientSearchResultToJSONTyped(value?: SearchResultsOfClientSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ClientSearchResultToJSON)),
        'hasMoreItems': value['hasMoreItems'],
    };
}

